// You can write your custom Javascript here

(() => {
  const select = document.getElementById('product-select');
  const submitButton = document.querySelector('.js-product-btn');
  const selectError = document.querySelector('.js-select-error');

  if(!select || !submitButton) return;

  select.addEventListener('change', (event) => {
    if(selectError) selectError.classList.toggle('hidden', event.target.value != '');
  });

  submitButton.addEventListener('click', (event) => {
    if(select.value != '') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    selectError.classList.remove('hidden');
  });
})();

(() => {
  function setHeaderHeight() {
    const header = document.querySelector('.header');
    if (header) {
      const height = header.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }
  }

  setHeaderHeight();

  window.addEventListener('resize', setHeaderHeight);
})();
